import { useCallback, useMemo, useState } from 'react';

import { Box } from '@occc-app/design-system';

import { SchedulePage } from './schedule-page.component';
import { CalendarViewToggle, KioskSelectorInput } from './components';

import { useScheduleKiosks } from '../../hooks/use-schedule-kiosks.hook';
import { useScheduleCalendar } from '../../hooks/use-schedule-calendar.hook';
import { useGetScheduleAdSets } from '../../hooks/use-get-schedule-ad-sets.hook';
import { mapAdSetsToScheduler } from '../../utils/schedule-mapper';

export const SchedulePageContainer = () => {
  const [isKioskDialogOpen, setIsKioskDialogOpen] = useState(false);

  const { selectedKioskIds, updateSelectedKioskIds, removeKiosk } = useScheduleKiosks();

  const { calendarView, selectedDay, setCalendarView, goToNextDay, goToPrevDay } =
    useScheduleCalendar();

  const { data: adSets, loading: adSetsLoading } = useGetScheduleAdSets({
    kioskIds: selectedKioskIds,
  });

  const scheduler = useMemo(() => {
    if (!adSets || adSets.length === 0 || selectedKioskIds.length === 0) {
      return undefined;
    }
    return mapAdSetsToScheduler({ adSets, selectedKioskIds });
  }, [adSets, selectedKioskIds]);

  const handleOpenKioskDialog = useCallback(() => {
    setIsKioskDialogOpen(true);
  }, []);

  const handleCloseKioskDialog = useCallback(() => {
    setIsKioskDialogOpen(false);
  }, []);

  const tableActions = useMemo(
    () => (
      <>
        {selectedKioskIds.length > 0 && (
          <Box mr={2}>
            <CalendarViewToggle value={calendarView} onChange={setCalendarView} />
          </Box>
        )}
        <KioskSelectorInput
          selectedKioskIds={selectedKioskIds}
          onRemoveKiosk={removeKiosk}
          onClick={handleOpenKioskDialog}
          loading={adSetsLoading}
        />
      </>
    ),
    [
      selectedKioskIds,
      calendarView,
      setCalendarView,
      removeKiosk,
      handleOpenKioskDialog,
      adSetsLoading,
    ],
  );

  return (
    <SchedulePage
      calendarView={calendarView}
      selectedDay={selectedDay}
      scheduler={scheduler}
      loading={adSetsLoading}
      tableActions={tableActions}
      isKioskDialogOpen={isKioskDialogOpen}
      onCloseKioskDialog={handleCloseKioskDialog}
      onConfirmKioskSelection={updateSelectedKioskIds}
      selectedKioskIds={selectedKioskIds}
      onPrevDayClick={goToPrevDay}
      onNextDayClick={goToNextDay}
      onSelectKiosk={handleOpenKioskDialog}
    />
  );
};
